import React from 'react';
import { useSelector } from 'react-redux';
import T from 'src/components/content-manager/translator/T';
import { useCurrencyFormat } from 'src/core/hooks/format';
import { useAppMeta } from 'src/core/provider/AppMeta';
import { getShippingCostTable } from 'src/store/shipping-cost-table/selectors';

const FreeShippingCostSnippet: React.FC = () => {
    const { selectedRegionKey } = useAppMeta();
    const currencyFormat = useCurrencyFormat();
    const shippingCostTable = useSelector(getShippingCostTable);

    if (shippingCostTable.content == null) return null;
    const freeShippingCost = shippingCostTable.content.getFreeShippingCostByRegion(selectedRegionKey);

    if (freeShippingCost == null) return null;

    return (
        <T
            k="shop.shipping_cost_table_discover.free_shipping"
            options={{
                value: currencyFormat({
                    currency: freeShippingCost.currencyIso,
                    maximumFractionDigits: 0,
                })(freeShippingCost.value),
            }}
        />
    );
};

export default FreeShippingCostSnippet;
